import { keyframes } from "@emotion/react";
import { Grid, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React from "react";
import BreadcrumbPart from "./BreadcrumbPart";
const ImgLogo = styled("img")(({ theme, width, height }) => ({
    zIndex: 2,
    position: "relative",
    width: width,
    height: height,
}));
const Grid_container = styled(Grid)(({ theme }) => ({
    animation: `${keyframes_move_logo} 2s, ${keyframes_invisible} 2.5s`,
    overflow: "hidden",
}));
const Grid_breadcrumbEntry = styled(Grid)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
}));
const keyframes_move_logo = keyframes({
    "0%": {
        marginLeft: "40vw",
    },
    "100%": {
        marginLeft: 0,
    },
});
const keyframes_invisible = keyframes({
    "0%": {
        maxWidth: "8rem",
    },
    "100%": {
        maxWidth: "8rem",
    },
});
export const Breadcrumb = observer((props) => {
    const titleOnClick = () => {
        window.location.hash = "";
    };
    const renderContent = () => {
        if (props.children) {
            return props.children;
        }
        else {
            let title = props.appModel.config.appName;
            if (props.appModel.custom.title) {
                title = props.appModel.i18nFromData(props.appModel.custom.title, title);
            }
            let titleOnClickRefined = undefined;
            if ("titleClick" in props.appModel.custom) {
                if (typeof props.appModel.custom.titleClick == "function") {
                    titleOnClickRefined = props.appModel.custom.titleClick;
                }
                else if (props.appModel.custom.titleClick) {
                    titleOnClickRefined = titleOnClick;
                }
            }
            return (React.createElement(BreadcrumbPart, { entry: {
                    label: props.appModel.i18nFromData(props.appModel.custom.title, title),
                    onClick: titleOnClickRefined,
                }, appModel: props.appModel }));
        }
    };
    const logoConfig = props.appModel.theme.logoConfig;
    return (React.createElement(Grid_container, { item: true, container: true, wrap: "nowrap", md: 9, sm: 8, xs: 10, style: {
            height: "6rem", //"var(--side-menu-width)",
            paddingLeft: "1rem",
        } },
        React.createElement(Grid_breadcrumbEntry, { item: true },
            React.createElement(Link, { color: "inherit", href: props.appModel.appState.homeUrl, onClick: () => { } },
                React.createElement(ImgLogo, { src: logoConfig["path"], width: logoConfig["width"], height: logoConfig["height"] }))),
        renderContent()));
});
export default Breadcrumb;
